/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CloneDashboardRequest } from '../../models/clone-dashboard-request';
import { DashboardDto } from '../../models/dashboard-dto';

export interface DashboardsDashboardIdClonePost$Plain$Params {
  dashboardId: string;
      body?: CloneDashboardRequest
}

export function dashboardsDashboardIdClonePost$Plain(http: HttpClient, rootUrl: string, params: DashboardsDashboardIdClonePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DashboardDto>> {
  const rb = new RequestBuilder(rootUrl, dashboardsDashboardIdClonePost$Plain.PATH, 'post');
  if (params) {
    rb.path('dashboardId', params.dashboardId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DashboardDto>;
    })
  );
}

dashboardsDashboardIdClonePost$Plain.PATH = '/dashboards/{dashboardId}/clone';
